import React from 'react';
import { FormControl } from 'react-bootstrap';
import { normalizeId, getFormattedDate } from '../helpers/utility';
import PasswordInput from '../../components/common/PasswordInput';

const TextInput = ({
  id,
  title,
  onChange,
  onChangeWindow,
  onFormChange,
  value,
  preValue,
  className = '',
  textArea = false,
  hint = '',
  required = false,
  variant = 'text',
  onClick,
  disabled = false,
  onKeyPress,
  compact = false,
  size,
  min,
  max,
  row = 2,
  autoComplete = 'off'
}) => {
  let defaultValue = value || preValue;
  if (variant === 'date') {
    if (defaultValue) {
      const date = new Date(defaultValue);
      defaultValue = getFormattedDate(date);
    }

    if (min) {
      const date = new Date(min);
      min = getFormattedDate(date);
    }

    if (max) {
      const date = new Date(max);
      max = getFormattedDate(date);
    }
  }

  const internalOnChange = e => {
    if (onChange) onChange(e);
    if (onChangeWindow && window[onChangeWindow]) {
      window[onChangeWindow](e);
    }
    if (onFormChange) onFormChange(e);
  };

  if (variant === 'password') {
    return (
      <PasswordInput
        id={id || normalizeId(title)}
        onChange={internalOnChange}
        defaultValue={defaultValue}
        className={className}
        placeholder={hint}
        required={required}
        onClick={onClick}
        disabled={disabled}
        onKeyPress={onKeyPress}
        size={size}
        autoComplete={autoComplete}
      />
    );
  }

  return (
    <FormControl
      id={id || normalizeId(title)}
      type={variant}
      onChange={internalOnChange}
      defaultValue={defaultValue}
      className={className}
      as={textArea ? 'textarea' : 'input'}
      placeholder={hint}
      required={required}
      onClick={onClick}
      disabled={disabled}
      onKeyPress={onKeyPress}
      size={size}
      min={min}
      max={max}
      rows={row}
      autoComplete={autoComplete}
    />
  );
};

export default TextInput;
